import { atom } from "jotai";
import { EProfileTab } from "library/types";

export const selectedProfileTabAtom = atom<EProfileTab>(EProfileTab.info);
